import {
  ChamberMemberProSettingsSectionEnum,
  useGetChamberMemberProSettingsQuery,
} from "../graphql/types";
import type { getPreserveExpectedErrorsForCallerContext } from "../utils/apolloErrorPolicy";

type CmpSettingsQueryContext = ReturnType<
  typeof getPreserveExpectedErrorsForCallerContext
>;

type CmpSettingsFetchPolicy =
  | "cache-first"
  | "cache-and-network"
  | "network-only"
  | "no-cache"
  | "standby";

const useCmpSettingsSection = (
  chamberId: string,
  section: ChamberMemberProSettingsSectionEnum,
  fetchPolicy?: CmpSettingsFetchPolicy,
  context?: CmpSettingsQueryContext
) =>
  useGetChamberMemberProSettingsQuery({
    variables: { chamberId, section },
    skip: !chamberId,
    fetchPolicy,
    ...(context ? { context } : {}),
  });

export const useCmpGlobalSettings = (
  chamberId: string,
  fetchPolicy?: CmpSettingsFetchPolicy,
  context?: CmpSettingsQueryContext
) =>
  useCmpSettingsSection(
    chamberId,
    ChamberMemberProSettingsSectionEnum.GlobalSettings,
    fetchPolicy,
    context
  );

export const useCmpMembershipSettings = (
  chamberId: string,
  fetchPolicy?: CmpSettingsFetchPolicy,
  context?: CmpSettingsQueryContext
) =>
  useCmpSettingsSection(
    chamberId,
    ChamberMemberProSettingsSectionEnum.MembershipSettings,
    fetchPolicy,
    context
  );

export const useCmpEmailSettings = (
  chamberId: string,
  fetchPolicy?: CmpSettingsFetchPolicy,
  context?: CmpSettingsQueryContext
) =>
  useCmpSettingsSection(
    chamberId,
    ChamberMemberProSettingsSectionEnum.EmailAndCommunicationSettings,
    fetchPolicy,
    context
  );

export const useCmpGovernanceSettings = (
  chamberId: string,
  fetchPolicy?: CmpSettingsFetchPolicy,
  context?: CmpSettingsQueryContext
) =>
  useCmpSettingsSection(
    chamberId,
    ChamberMemberProSettingsSectionEnum.GovernanceSettings,
    fetchPolicy,
    context
  );
